import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import DevopsDashboard from './pages/DevopsDashboard';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import VerifyEmail from './pages/VerifyEmail';
import ResendVerification from './pages/ResendVerification';
import NeuralTaskGateway from './pages/NeuralTaskGateway';
import TaskDashboard from './pages/TaskDashboard';
import TaskHatchDetail from './pages/TaskHatchDetail';
import TaskGetEmail from './pages/TaskGetEmail';
import TaskHatch from './pages/TaskHatch';
import ImplementationGuides from './pages/ImplementationGuides';
import AgentDashboard from './pages/AgentDashboard';
import TaskerProfile from './pages/TaskerProfile';
import TaskerMeta from './pages/TaskerMeta';
import Tasker from './pages/Tasker';
import SearchGuides from './pages/SearchGuides';
import TaskMarketplace from './pages/TaskMarketplace';
import TaskBuddies from './pages/TaskBuddies';
import Notifications from './pages/Notifications';
import ProfileSettings from './pages/ProfileSettings';
import ProtectedRoute from './components/ProtectedRoute';
import TaskAssign from './pages/TaskAssign';
import AnimationExport from './pages/AnimationExport';
import MyWorkspace from './pages/MyWorkspace';
import RankingGuide from './pages/RankingGuide';

const App = () => {
  return (
    <Routes>
      <Route path="/export-animation" element={<AnimationExport />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/resend-verification" element={<ResendVerification />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route
          path="services/devops-dashboard"
          element={
            <ProtectedRoute>
              <DevopsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="neural-task-gateway"
          element={
            <ProtectedRoute>
              <NeuralTaskGateway />
            </ProtectedRoute>
          }
        />
        <Route
          path="task-dashboard"
          element={
            <ProtectedRoute>
              <TaskDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="my-workspace"
          element={
            <ProtectedRoute>
              <MyWorkspace />
            </ProtectedRoute>
          }
        />
        <Route
          path="taskman"
          element={
            <ProtectedRoute>
              <TaskAssign />
            </ProtectedRoute>
          }
        />
        <Route
          path="task-buddies"
          element={
            <ProtectedRoute>
              <TaskBuddies />
            </ProtectedRoute>
          }
        />
        <Route
          path="tasks/:taskId/get-email"
          element={
            <ProtectedRoute>
              <TaskGetEmail />
            </ProtectedRoute>
          }
        />
        <Route
          path="tasks/:taskId"
          element={
            <ProtectedRoute>
              <TaskHatchDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="tasker-profile"
          element={
            <ProtectedRoute>
              <TaskerProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="tasker-meta"
          element={
            <ProtectedRoute>
              <TaskerMeta />
            </ProtectedRoute>
          }
        />
        <Route
          path="profile-settings"
          element={
            <ProtectedRoute>
              <ProfileSettings />
            </ProtectedRoute>
          }
        />
        <Route path="tasker/:userId" element={<Tasker />} />
        <Route
          path="task-hatch"
          element={
            <ProtectedRoute>
              <TaskHatch />
            </ProtectedRoute>
          }
        />
        <Route
          path="implementation-guides"
          element={
            <ProtectedRoute>
              <ImplementationGuides />
            </ProtectedRoute>
          }
        />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="search-guides" element={<SearchGuides />} />
        <Route path="marketplace" element={<TaskMarketplace />} />
        <Route path="ranking-guide" element={<RankingGuide />} />
        <Route
          path="notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-dashboard"
          element={
            <ProtectedRoute>
              <AgentDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};


export default App;
